import { hours } from '../../common/utils/format';
import { get } from '../../../container';
import {
  GET_PROFILE_LOADING,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_AVATAR_SUCCESS,
} from '../actions/profile';

const initialState = {
  me: {},
  loading: true,
  error: null,
};

function formatAvatar(avatarUrl) {
  return avatarUrl ? `${get('api_host')}${avatarUrl}` : null;
}

/**
 * @param {Object} exchange
 *
 * @return {Object}
 */
function formatExchange(exchange) {
  return {
    uuid: exchange.uuid,
    duration: exchange.duration,
  };
}

/**
 * @param {Object} service
 *
 * @return {Object}
 */
function formatService(service) {
  return {
    uuid: service.uuid,
    name: service.name,
  };
}

/**
 * @param {Object} service
 *
 * @return {Object}
 */
function formatProfile(profile) {
  return {
    uuid: profile.uuid,
    avatar: formatAvatar(profile.avatar),
    firstname: profile.firstname,
    lastname: profile.lastname,
    city: profile.address.city,
    zipcode: profile.address.zipcode,
    comment: profile.comment,
    balance: hours(profile.balance),
    given: profile.given.map(formatExchange),
    received: profile.received.map(formatExchange),
    supplies: profile.supplies.map(formatService),
    demands: profile.demands.map(formatService),
  };
}

/**
 * Profile reducer
 *
 * @param {Object} state
 * @param {Object} action
 *
 * @return {Object}
 */
export default function profile(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_PROFILE_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        me: formatProfile(payload.profile),
      };

    case GET_PROFILE_FAILURE:
      return {
        ...state,
        loading: false,
        error: (payload && payload.status.message) || null,
      };

    case UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        me: {
          ...state.me,
          comment: payload.comment,
        },
      }

    case UPDATE_AVATAR_SUCCESS:
      return {
        ...state,
        me: {
          ...state.me,
          avatar: formatAvatar(payload.avatar),
        },
      }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/profile/reducers/profile.js